import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: null,
  token: null,
  isAuthenticated: false,
  authInitialized: false,

  login: (user, token) => {
    set({
      user,
      token,
      isAuthenticated: true,
      authInitialized: true
    });
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
  },

  logout: () => {
    set({
      user: null,
      token: null,
      isAuthenticated: false,
      authInitialized: true
    });
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  setUser: (user) => {
    set({ user });
    localStorage.setItem('user', JSON.stringify(user));
  },

  restoreAuth: () => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    if (token && user) {
      try {
        set({
          token,
          user: JSON.parse(user),
          isAuthenticated: true,
          authInitialized: true
        });
        return;
      } catch (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    set({ authInitialized: true });
  }
}));
